import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
    const { language } = useLanguage();

    return (
        <footer className="py-10 bg-gray-950 text-gray-400">
            <div className="container mx-auto px-6">
                <div className="text-center text-sm">
                    <div className="flex flex-col md:flex-row justify-center items-center gap-2">
                        <p>© 2025 HASSAN LAFANI. {language === 'en' ? 'All Rights Reserved.' : 'Tous Droits Réservés.'}</p>
                        <span className="hidden md:inline text-gray-700">|</span>
                        <p className="text-gray-600">
                            {language === 'en' ? 'Designed for Champions' : 'Conçu pour les Champions'}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
